import CustomerAPI from 'api/customer';
import events from 'lib/events';
import PrintableSummary from '../../components/printableSummary';
import React from 'react';
import {formatCurrency} from 'helpers/dashboardFormatter';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import PropTypes from 'prop-types';
import moment from 'moment';

class ReportSummary extends React.Component {
  static propTypes = {
    intl: intlShape,
    dateFrom: PropTypes.string,
    dateTo: PropTypes.string,
  };

  state = {};

  export = () => CustomerAPI.exportTruBlueSummaryReport(
    this.props.intl.locale,
    this.props.store, this.props.status, this.props.dateFrom, this.props.dateTo);

  printReport = data => {
    let summary = data;
    let {formatMessage} = this.props.intl;
    const columns = [
      {name: formatMessage({id: 'general.total.accounts'}), key: 'TotalAccounts'},
      {name: formatMessage({id: 'reports.active.trublue.accounts'}), key: 'ActiveAccounts'},
      {name: formatMessage({id: 'reports.inactive.trublue.accounts'}), key: 'InactiveAccounts'},
      {name: formatMessage({id: 'reports.eligible.trublue.accounts'}), key: 'EligibleAccounts'},
      {name: formatMessage({id: 'reports.total.trublue.pools'}), key: 'TotalPools'},
      {name: formatMessage({id: 'reports.trublue.in.ground'}), key: 'InGroundPools'},
      {name: formatMessage({id: 'reports.trublue.above.ground'}), key: 'AboveGroundPools'},
      {name: formatMessage({id: 'reports.trublue.splasher.pools'}), key: 'SplasherGroundPools'},
      {name: formatMessage({id: 'reports.trublue.swim.spas'}), key: 'SwimSpas'},
    ];
    let posColumns = [
      {name: formatMessage({id: 'reports.trublue.purchasing.accounts'}), key: 'POSTotalPurchasingAccounts'},
      {name: formatMessage({id: 'reports.trublue.account.value'}), key: 'POSTotalAccountValue'},
      {name: formatMessage({id: 'reports.trublue.average.value'}), key: 'POSAverageAccountValue'},
    ];

    summary.POSTotalPurchasingAccounts = formatCurrency(summary.POSTotalPurchasingAccounts);
    summary.POSTotalAccountValue = formatCurrency(summary.POSTotalAccountValue);
    summary.POSAverageAccountValue = formatCurrency(summary.POSAverageAccountValue);
    if (this.props.POSActive) {
      columns.push(...posColumns);
    }
    return <PrintableSummary summary={summary}
                             columns={columns}
                             dateLabel={formatMessage({id: 'general.date'})}
                             date={this.getDateRange()}
                             title={formatMessage({id: 'reports.customer.trublue.accounts'})}/>;
  };

  render() {
    let data = this.props.data;
    let pos;
    let tilesPOS;
    let tilesPools;
    let tilesTrublueState;
    let {formatMessage} = this.props.intl;

    if (data && Object.keys(data).length) {
      let summary = [
        {title: formatMessage({id: 'general.total.accounts'}), value: data.TotalAccounts},
        {title: formatMessage({id: 'reports.active.trublue.accounts'}), value: data.ActiveAccounts},
        {title: formatMessage({id: 'reports.inactive.trublue.accounts'}), value: data.InactiveAccounts},
        {title: formatMessage({id: 'reports.eligible.trublue.accounts'}), value: data.EligibleAccounts},
        {title: formatMessage({id: 'reports.opportunity.trublue.accounts'}), value: data.OpportunityAccounts},
        {
          title: formatMessage({id: 'reports.ineligible.trublue.accounts'}),
          value: Math.max(0, (data.TotalAccounts || 0) -
            (data.ActiveAccounts || 0) -
            (data.InactiveAccounts || 0) -
            (data.EligibleAccounts || 0) -
            (data.OpportunityAccounts || 0)),
        },
        {title: formatMessage({id: 'reports.total.trublue.pools'}), value: data.TotalPools},
        {title: formatMessage({id: 'reports.trublue.in.ground'}), value: data.InGroundPools},
        {title: formatMessage({id: 'reports.trublue.above.ground'}), value: data.AboveGroundPools},
        {title: formatMessage({id: 'reports.trublue.splasher.pools'}), value: data.SplasherGroundPools},
        {title: formatMessage({id: 'reports.trublue.swim.spas'}), value: data.SwimSpas},
      ];

      tilesTrublueState = summary.slice(0, 6).map((cart, i) =>
        <div className="col-sm-3"
             key={i}>
          {cart.title} <br/>
          <span>{cart.value}</span>
        </div>
      );

      tilesPools = summary.slice(6, summary.length).map((cart, i) =>
        <div className="col-sm-3"
             key={i}>
          {cart.title} <br/>
          <span>{cart.value}</span>
        </div>
      );

      pos = [
        {title: formatMessage({id: 'reports.trublue.purchasing.accounts'}), value: data.POSTotalPurchasingAccounts},
        {
          title: formatMessage({id: 'reports.trublue.account.value'}),
          value: +(data.POSTotalAccountValue ? data.POSTotalAccountValue : 0),
        },
        {
          title: formatMessage({id: 'reports.trublue.average.value'}),
          value: +(data.POSAverageAccountValue ? data.POSAverageAccountValue : 0),
        },
      ];

      tilesPOS = pos.map((cart, i) => {
        if (cart.title !== 'Total Purchasing Tru-Blue Accounts') {
          return <div className="col-sm-3"
                      key={i}>
            {cart.title} <br/>
            {formatCurrency(cart.value)}
          </div>;
        }

        return <div className="col-sm-3"
                    key={i}>
          {cart.title} <br/>
          <span>{cart.value}</span>
        </div>;
      });
    }

    const start = this.props.dateFrom;
    const end = this.props.dateTo;

    const dateRange = moment(start).year() === moment().year() ?
      <FormattedMessage id='general.present.range.labelled'
                        values={{
                          start,
                        }} /> :
      <FormattedMessage id='general.date.range.labelled'
                        values={{
                          start,
                          end,
                        }} />;

    return <div>
      <div className="summary-container">
        <h2><FormattedMessage id="reports.report.summary"/></h2>
        <span className={this.props.dateFrom ?
          'summary-date' :
          'not-show'}> | {dateRange}
        </span>
        <br/>
        <span><FormattedMessage id="reports.reveal.report.summary"/></span>
        {this.props.showNoDataMessage ?
          <label className="report-no-data"><FormattedMessage id="reports.error.no.results"/></label> : ''}
        <div className="container-fluid custom-container-margins">
          <div className={Object.keys(data).length ? 'row' : 'not-show'}
               id="row-no-padding">
            {tilesTrublueState}
          </div>
          <div className={Object.keys(data).length ? 'row' : 'not-show'}
               id="row-no-padding">
            {tilesPools}
          </div>
          <div className={this.props.POSActive ? 'row' : 'not-show'}
               id="row-no-padding">
            {tilesPOS}
          </div>
        </div>
      </div>
      <div className='col-sm-12 button-group shift-right'>
        <button className='btn btn-default pull-right'
                disabled={Object.keys(data).length <= 0}
                onClick={() => {
                  events.publish('print', this.printReport(this.props.data));
                }}><FormattedMessage id="reports.print.summary"/></button>
        <button className='btn btn-primary pull-right'
                onClick={this.export}><FormattedMessage id="reports.export.report"/></button>
      </div>
    </div>;
  }
}

export default injectIntl(ReportSummary);
